package navigation.home.proposal.allproposal

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.*
import androidx.compose.runtime.getValue
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.input.key.KeyEventType
import androidx.compose.ui.input.key.key
import androidx.compose.ui.input.key.type
import androidx.compose.ui.unit.dp
import cafe.adriel.voyager.koin.koinScreenModel
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow
import com.essntl.components.sidepanel.*
import com.essntl.features.client.domain.model.ClientModel
import com.essntl.features.client.ui.AddEditClientDialog
import com.essntl.features.client.ui.addeditclient.AddEditClientEvent
import com.essntl.features.invoice.ui.allinvoice.InvoiceEvent
import com.essntl.features.invoice.ui.allinvoice.InvoiceState
import com.essntl.features.itinerary.ui.all_itinerary.AllItineraryEvent
import com.essntl.features.itinerary.ui.edit_itinerary_service.components.ContactDetailsDialog
import com.essntl.features.organization.domain.model.OrganizationModel
import com.essntl.features.proposal.domain.model.ProposalModel
import com.essntl.features.proposal.ui.allproposal.AllProposalEvent
import com.essntl.features.proposal.ui.allproposal.AllProposalNavigation
import com.essntl.features.proposal.ui.allproposal.AllProposalScreen
import com.essntl.features.proposal.ui.proposalhistory.ProposalOverviewEvent
import com.essntl.features.proposal.ui.proposalhistory.ProposalOverviewNavigation
import com.essntl.features.proposal.ui.proposalhistory.ProposalOverviewScreen
import com.essntl.features.proposal.ui.proposalhistory.ProposalOverviewState
import essntl.key.LocalKeyEventManager
import com.essntl.uikit.components.iconbutton.outline.EsMediumOutlineIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.link.NavLinkState
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import kotlinx.coroutines.flow.collectLatest
import navigation.home.address.AddressScreenModel
import navigation.home.clients.addeditclient.AddEditClientScreenModel
import navigation.home.contact.ContactScreenModel
import navigation.home.customfields.CustomFieldsScreenModel
import navigation.home.invoice.addeditinvoice.AddEditInvoiceScreenNav
import navigation.home.invoice.allinvoice.AllInvoiceScreenModel
import navigation.home.organization.OrganizationScreenModel
import navigation.home.proposal.addeditproposal.AddEditProposalScreenNav
import navigation.home.proposal.proposal.ProposalOverviewScreenModel
import navigation.utils.NavLinkScreen
import navigation.utils.safePush
import org.koin.core.qualifier.named

object AllProposalScreenNav : NavLinkScreen {
    override val defaultTitle: String = "Proposals"

    override var navLinkState: NavLinkState by mutableStateOf(
        NavLinkState(
            title = defaultTitle,
            iconRes = EsIcons.Proposal,
        ),
    )

    @Composable
    override fun Content() {
        val allProposalScreenModel = koinScreenModel<AllProposalScreenModel>()
        val allProposalState by allProposalScreenModel.state.collectAsState()

        val invoiceScreenModel = koinScreenModel<AllInvoiceScreenModel>()
        val invoiceState by invoiceScreenModel.state.collectAsState()

        val proposalOverviewScreenModel = koinScreenModel<ProposalOverviewScreenModel>()
        val proposalOverviewState by proposalOverviewScreenModel.state.collectAsState()

        val organizationScreenModel = koinScreenModel<OrganizationScreenModel>()
        val organizationState by organizationScreenModel.state.collectAsState()

        val contactScreenModel = koinScreenModel<ContactScreenModel>()
        val contactState by contactScreenModel.state.collectAsState()

        val organizationAddressScreenModel = koinScreenModel<AddressScreenModel>(named("organization"))
        val organizationAddressState by organizationAddressScreenModel.state.collectAsState()

        val contactAddressScreenModel = koinScreenModel<AddressScreenModel>(named("contact"))
        val contactAddressState by contactAddressScreenModel.state.collectAsState()

        val customFieldsScreenModel = koinScreenModel<CustomFieldsScreenModel>()
        val customFieldsState by customFieldsScreenModel.state.collectAsState()

        var isChangeContactPopupOpen by rememberSaveable { mutableStateOf(false) }
        var proposalToEdit by remember { mutableStateOf<ProposalModel?>(null) }

        val navigator = LocalNavigator.currentOrThrow
        val keyEventManager = LocalKeyEventManager.current

        val addEditClientScreenModel = koinScreenModel<AddEditClientScreenModel>()
        val addEditClientState by addEditClientScreenModel.state.collectAsState()
        var openAddEditClientDialog by rememberSaveable { mutableStateOf(false) }
        var clientToEdit by remember { mutableStateOf<ClientModel?>(null) }

        val sidePanelState =
            rememberSidePanelState(
                sidePanelVisible = false,
                panelSizeConstraint =
                    SizeConstraint(
                        minSize = 300.dp,
                        maxSize = 600.dp,
                    ),
            )

        LaunchedEffect(keyEventManager) {
            keyEventManager.events.collectLatest {
                if (it.key == Key.H && it.type == KeyEventType.KeyUp) {
                    sidePanelState.sidePanelOpened = false
                }
            }
        }

        LaunchedEffect(Unit) {
            allProposalScreenModel.onEvent(AllProposalEvent.GetAllProposal)
            navLinkState = navLinkState.copy(
                onRefresh = {
                    allProposalScreenModel.onEvent(AllProposalEvent.GetAllProposal)
                    sidePanelState.sidePanelOpened = false
                },
            )
        }

        LaunchedEffect(sidePanelState.sidePanelOpened) {
            if (!sidePanelState.sidePanelOpened) {
                allProposalScreenModel.onEvent(AllProposalEvent.SelectProposal(""))
                proposalToEdit = null
            }
        }

        LaunchedEffect(allProposalState.addEditProposal.isSuccess) {
            if (allProposalState.addEditProposal.isSuccess) {
                allProposalScreenModel.onEvent(AllProposalEvent.ClearProposalState)
                isChangeContactPopupOpen = false
                proposalToEdit = null
                addEditClientScreenModel.onEvent(AddEditClientEvent.ClearClientState)
                openAddEditClientDialog = false
                clientToEdit = null
            }
        }

        LaunchedEffect(addEditClientState.addEditClient.isSuccess) {
            if (addEditClientState.addEditClient.isSuccess) {
                addEditClientState.addEditClient.data?.let {
                    proposalToEdit?.let { proposal ->
                        allProposalScreenModel.onEvent(
                            AllProposalEvent.UpdateProposal(proposal),
                        )
                    }
                }
            }
        }

        SidePanel(
            sidePanelState = sidePanelState,
            isHorizontal = true,
            sidePanel = {
                Column(
                    modifier =
                        Modifier
                            .fillMaxHeight()
                            .padding(end = 1.5f.spacing)
                            .clip(RoundedCornerShape(EsConstants.SectionBorderRadius)),
                ) {
                    AllProposalSidePanelHeader(
                        proposalOverviewScreenModel = proposalOverviewScreenModel,
                        proposalOverviewState = proposalOverviewState,
                        sidePanelState = sidePanelState,
                    )

                    AllProposalSidePanelContent(
                        proposalOverviewState = proposalOverviewState,
                        invoiceState = invoiceState,
                        onInvoiceEvent = invoiceScreenModel::onEvent,
                        allProposalScreenModel = allProposalScreenModel,
                    )
                }
            },
            splitter =
                Splitter(
                    measuredPart = {
                        Box(
                            modifier =
                                Modifier
                                    .width(1.spacing)
                                    .fillMaxHeight(),
                        )
                    },
                ),
            modifier =
                Modifier
                    .fillMaxSize(),
        ) {
            AllProposalScreen(
                isSidePanelOpen = sidePanelState.sidePanelOpened,
                state = allProposalState,
                onEvent = allProposalScreenModel::onEvent,
                onNavigation = {
                    when (it) {
                        is AllProposalNavigation.AddProposal -> {
                            navigator.safePush(
                                AddEditProposalScreenNav(),
                            )
                        }

                        is AllProposalNavigation.EditProposal -> {
                            navigator.safePush(
                                AddEditProposalScreenNav(
                                    proposalId = it.id,
                                ),
                            )
                        }

                        is AllProposalNavigation.Proposal -> {
                            proposalOverviewScreenModel.onEvent(ProposalOverviewEvent.GetProposal(it.id))
                            allProposalScreenModel.onEvent(AllProposalEvent.SelectProposal(it.id))
                            sidePanelState.sidePanelOpened = true
                        }

                        is AllProposalNavigation.ProposalHistory -> {
                            proposalOverviewScreenModel.onEvent(
                                ProposalOverviewEvent.GetProposalHistory(
                                    id = it.id,
                                    proposalParentStatus = it.proposalParentStatus,
                                ),
                            )
                            allProposalScreenModel.onEvent(AllProposalEvent.SelectProposal(it.id))
                            sidePanelState.sidePanelOpened = true
                        }

                        is AllProposalNavigation.EditTravelAgent -> {
                            proposalToEdit = it.proposal
                            isChangeContactPopupOpen = true
                        }

                        is AllProposalNavigation.EditClient -> {
                            proposalToEdit = it.proposal
                            clientToEdit = it.proposal.primaryClient
                            openAddEditClientDialog = true
                        }

                        is AllProposalNavigation.CloseSidePanel -> {
                            sidePanelState.sidePanelOpened = false
                        }
                    }
                },
            )

            ContactDetailsDialog(
                isOpen = isChangeContactPopupOpen,
                onDismissRequest = {
                    isChangeContactPopupOpen = false
                    proposalToEdit = null
                },
                type = OrganizationModel.Type.TravelAgency,
                contact = proposalToEdit?.travelAgent?.contact,
                organizationState = organizationState,
                organizationEvent = organizationScreenModel::onEvent,
                organizationValidation = organizationScreenModel.validation,
                organizationAddressState = organizationAddressState,
                organizationAddressEvent = organizationAddressScreenModel::onEvent,
                organizationAddressValidation = organizationAddressScreenModel.validation,
                state = contactState,
                onEvent = contactScreenModel::onEvent,
                validation = contactScreenModel.validation,
                addressState = contactAddressState,
                onAddressEvent = contactAddressScreenModel::onEvent,
                addressValidation = contactAddressScreenModel.validation,
                customFieldsState = customFieldsState,
                onCustomFieldsEvent = customFieldsScreenModel::onEvent,
                isSaveEnabled = contactScreenModel.vm.isContactChanged() ||
                    contactAddressScreenModel.vm.isAddressChanged() ||
                    customFieldsScreenModel.vm.isCustomFieldsChanged(),
                onEditTravelAgent = {
                    proposalToEdit?.let { proposal ->
                        allProposalScreenModel.onEvent(
                            AllProposalEvent.UpdateProposal(proposal),
                        )
                    }
                },
            )

            AddEditClientDialog(
                openDialog = openAddEditClientDialog,
                currentClient = clientToEdit,
                state = addEditClientState,
                validation = addEditClientScreenModel.validation,
                onEvent = addEditClientScreenModel::onEvent,
                onDismissRequest = {
                    openAddEditClientDialog = false
                    clientToEdit = null
                },
            )
        }
    }

    @Composable
    private fun AllProposalSidePanelHeader(
        proposalOverviewScreenModel: ProposalOverviewScreenModel,
        proposalOverviewState: ProposalOverviewState,
        sidePanelState: SidePanelState,
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceBetween,
            modifier =
                Modifier
                    .background(color = MaterialTheme.esColorScheme.bgSecondary)
                    .padding(2.5f.spacing)
                    .fillMaxWidth(),
        ) {
            EsMediumOutlineIconButton(
                onClick = {
                    proposalOverviewScreenModel.onEvent(ProposalOverviewEvent.ClearState)
                    sidePanelState.sidePanelOpened = false
                },
                iconRes = EsIcons.ArrowRight,
            )

            Spacer(modifier = Modifier.width(2.5f.spacing))

            if (proposalOverviewState.getProposal.data != null)
                SelectionContainer {
                    Text(
                        text = proposalOverviewState.getProposal.data?.title ?: "",
                        color = MaterialTheme.esColorScheme.textPrimary,
                        style = MaterialTheme.esTypography.h3Bold24,
                    )
                }
        }
    }

    @Composable
    private fun AllProposalSidePanelContent(
        proposalOverviewState: ProposalOverviewState,
        invoiceState: InvoiceState,
        onInvoiceEvent: (InvoiceEvent) -> Unit,
        allProposalScreenModel: AllProposalScreenModel,
    ) {
        val navigator = LocalNavigator.currentOrThrow

        if (proposalOverviewState.getProposal.data != null) {
            ProposalOverviewScreen(
                state = proposalOverviewState,
                invoiceState = invoiceState,
                onInvoiceEvent = onInvoiceEvent,
                onCopyProposalHistory = { proposal ->
                    allProposalScreenModel.onEvent(
                        AllProposalEvent.MakeProposalCopy(proposal),
                    )
                },
                onNavigation = {
                    when (it) {
                        is ProposalOverviewNavigation.EditProposal -> {
                            navigator.safePush(
                                AddEditProposalScreenNav(
                                    proposalId = it.proposalId,
                                ),
                            )
                        }

                        is ProposalOverviewNavigation.EditInvoice -> {
                            navigator.safePush(
                                AddEditInvoiceScreenNav(
                                    invoiceId = it.invoiceId,
                                    proposalId = it.proposalId,
                                ),
                            )
                        }

                        is ProposalOverviewNavigation.AddInvoice -> {
                            navigator.safePush(
                                AddEditInvoiceScreenNav(
                                    proposalId = it.proposalId,
                                ),
                            )
                        }
                    }
                },
            )
        }
    }
}